import clsx from "clsx";
import React from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import withReduxProvider from "web/react/redux-provider";
import { closeSearch, openSearch } from "web/redux/ducks/app-header-bar";
import { ReduxStoreState } from "web/redux/store";
import analytics from "web/script/analytics/analytics";
import styles from "./search-button.module.css";

function extractState(state: ReduxStoreState): boolean {
    return state.appHeaderBarReducer.isSearchOpen;
}

export function SearchButton(): JSX.Element {
    const isSearchBarOpen = useReduxSelector(extractState);
    const dispatch = useDispatch();

    function onSearchClick(): void {
        if (!isSearchBarOpen) {
            dispatch(openSearch());
        } else if (isSearchBarOpen) {
            dispatch(closeSearch());
        }
        analytics.event("header", "clicked", "burger_menu_search_button_open");
    }

    return (
        <button id="searchButton" onClick={onSearchClick} className={styles.iconWrapper}>
            <SVGIcon className={clsx(styles.icon)} name={"search"} />
        </button>
    );
}

export default withReduxProvider(SearchButton);
